import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { APIService } from '../../../../core/providers/apiservices';
import { ControlDTO } from '../../../../core/data/ControlDTO';
import { ProducerDTO } from '../data/ProducerDTO';
import { CompanyDTO } from '../data/CompanyDTO';
import { ErrorDTO } from '../../../../core/data/ErrorDTO';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class ProducerProvider {
  private header = APIService.getHeader();
  itemret: any;

  constructor(public http: HttpClient, private translate: TranslateService) {}

  /**
   * GET users
   */
  get(filter:string, isDirectClient:string): Promise<any> {
    this.header = APIService.getHeader();
    return new Promise((resolve, reject) => {
      let url = APIService.API_URL + 'producer?operation=playerecine&filter=' + encodeURIComponent(filter) + '&isDirectClient=' + encodeURIComponent(isDirectClient);
      this.http.get(url, { headers: this.header }).subscribe({
        next: (response) => {
          var jsonData:ControlDTO = response;
          resolve(jsonData);
          
        },
        error: (err) => {
          var errorData: ErrorDTO = err?.error;
          errorData.responseMessage = this.translate.instant(`ERROR_MESSAGES.${errorData.responseCode ?? ''}`);
          reject(errorData);
        }
      });
    });
  }

  /**
   * POST producer
   */
  post(producer: ProducerDTO): Promise<any> {
    this.header = APIService.getHeader();
    return new Promise((resolve, reject) => {
      let url = APIService.API_URL + 'producer';
      const requestData = JSON.stringify(producer);
      this.http.post(url, requestData, { headers: this.header }).subscribe({
        next: (response) => {
          var jsonData:ProducerDTO = response;
          resolve(jsonData);
          
        },
        error: (err) => {
          var errorData: ErrorDTO = err?.error;
          errorData.responseMessage = this.translate.instant(`ERROR_MESSAGES.${errorData.responseCode ?? ''}`);
          reject(errorData);
        }
      });
    });
  }

  /**
   * DELETE producer by producerName
   */
  delete(guidProducer: string): Promise<any> {
    this.header = APIService.getHeader();
    return new Promise((resolve, reject) => {
      let url = APIService.API_URL + `producer?id=${guidProducer}`;
      this.http.delete(url, { headers: this.header }).subscribe({
        next: (response) => {
          var jsonData:ProducerDTO = response;
          resolve(jsonData);
          
        },
        error: (err) => {
          var errorData: ErrorDTO = err?.error;
          errorData.responseMessage = this.translate.instant(`ERROR_MESSAGES.${errorData.responseCode ?? ''}`);
          reject(errorData);
        }
      });
    });
  }

  /**
   * Get Company using inserted CNPJ 
   * @param cnpj 
   * @returns 
   */
  getCompanyByCNPJ(cnpj:string): Promise<any> {
    this.header = APIService.getHeader();
    return new Promise((resolve, reject) => {
      let url = APIService.API_URL + 'producer?operation=searchbycnpj&cnpj=' + encodeURIComponent(cnpj);
      this.http.get(url, { headers: this.header }).subscribe({
        next: (response:CompanyDTO) => {
          resolve(response);
          
        },
        error: (err) => {
          var errorData: ErrorDTO = err?.error;
          errorData.responseMessage = this.translate.instant(`ERROR_MESSAGES.${errorData.responseCode ?? ''}`);
          reject(errorData);
        }
      });
    });
  }

}
